var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-rate',{attrs:{"allowHalf":_vm.allowHalf,"count":_vm.count},model:{value:(_vm.ctrl.value),callback:function ($$v) {_vm.$set(_vm.ctrl, "value", $$v)},expression:"ctrl.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }